import { render, staticRenderFns } from "./CustomerStoreStatistics.vue?vue&type=template&id=831437fc&scoped=true"
import script from "./CustomerStoreStatistics.vue?vue&type=script&lang=js"
export * from "./CustomerStoreStatistics.vue?vue&type=script&lang=js"
import style0 from "./CustomerStoreStatistics.vue?vue&type=style&index=0&id=831437fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831437fc",
  null
  
)

export default component.exports